<div>
     <!-- <fap-stock-layout
          [stockOverview]="stockOverview$ | async">
     </fap-stock-layout> -->
     <fap-stock-items [stockOverview]="stockOverview$ | async">

     </fap-stock-items>
</div>
